<template>
    <div class="suscribirse-screen">
        <div class="main-screen-component">
            <div class="main-screen">
                <ConversationSidebarComponent 
                    @show-toast="showToast"
                    :isSidebarMenuOpen="isSidebarMenuOpen" 
                    :new_conversation_info="new_conversation_info"
                    :conversation_id="conversation_id" 
                    :email="email" 
                    @conversation-selected="updateConversationSelected"
                    :is_new_conversation="is_new_conversation" 
                    :conversation_title="conversation_title"
                    :subscription="subscription"
                    :userProfilePicture="profilePicture"
                    :userName="name"
                    :permissions="permissions"
                    @logout="logout" />

                <SubscriptionComponent 
                    :email="email"
                    :permissions="permissions"
                    @show-toast="showToast"
                    @toggle-sidebar="toggleSidebar"
                    @logout="logout" />
            </div>
        </div>
        
        <!-- Toast notification -->
        <div v-if="toast.show" class="toast" :class="toast.type">
            {{ toast.message }}
        </div>
    </div>
</template>

<script>
import ConversationSidebarComponent from '../components/ConversationSidebarComponent.vue';
import SubscriptionComponent from '../components/SubscriptionComponent.vue';
import axios from 'axios';

export default {
    name: 'SuscribirseScreen',
    components: {
        ConversationSidebarComponent,
        SubscriptionComponent
    },
    data() {
        return {
            email: '',
            name: '',
            profilePicture: null,
            subscription: null,
            permissions: [],
            conversation_id: null,
            conversation_title: null,
            is_new_conversation: true,
            new_conversation_info: {
                conversation_title: null,
                conversation_id: null
            },
            isSidebarMenuOpen: false,
            toast: {
                show: false,
                message: '',
                type: 'info',
                timeout: null
            }
        };
    },
    methods: {
        updateConversationSelected(conversationId, conversationTitle, is_new) {
            this.conversation_id = conversationId;
            this.conversation_title = conversationTitle;
            this.is_new_conversation = is_new;
            this.isSidebarMenuOpen = false;
        },
        toggleSidebar() {
            this.isSidebarMenuOpen = !this.isSidebarMenuOpen;
        },
        logout() {
            // Make a post request to the logout endpoint first, then clear localStorage
            axios.post(process.env.VUE_APP_BASE_URL + '/api/auth/logout/')
                .then(() => {
                    // Clear user data from localStorage only after successful logout
                    localStorage.removeItem('user_email');
                    localStorage.removeItem('user_name');
                    localStorage.removeItem('user_permissions');
                    localStorage.removeItem('user_profile_picture');
                    localStorage.removeItem('user_subscription');
                    
                    console.log('Logged out');
                    this.showToast('Sesión cerrada. ¡Hasta la próxima!', 'success');
                    // Wait 2 seconds before redirecting to login
                    setTimeout(() => {
                        this.$router.push('/login');
                    }, 2000);
                })
                .catch((error) => {
                    console.error('Error logging out:', error);
                    this.showToast('Error al intentar cerrar sesión.', 'error');
                    
                    // Clear localStorage even on error for security
                    localStorage.removeItem('user_email');
                    localStorage.removeItem('user_name');
                    localStorage.removeItem('user_permissions');
                    localStorage.removeItem('user_profile_picture');
                    localStorage.removeItem('user_subscription');
                    
                    // Still redirect to login page even if there's an error
                    setTimeout(() => {
                        this.$router.push('/login');
                    }, 2000);
                });
        },
        showToast(message, type = 'info') {
            // Clear any existing timeout
            if (this.toast.timeout) {
                clearTimeout(this.toast.timeout);
            }
            
            // Show the toast
            this.toast.show = true;
            this.toast.message = message;
            this.toast.type = type;
            
            // Set a timeout to hide the toast
            this.toast.timeout = setTimeout(() => {
                this.toast.show = false;
            }, 3000);
        }
    },
    mounted() {
        // Get user data from localStorage
        this.email = localStorage.getItem('user_email') || '';
        this.name = localStorage.getItem('user_name') || '';
        this.profilePicture = localStorage.getItem('user_profile_picture') || null;
        
        // Parse JSON data from localStorage
        try {
            const subscriptionData = localStorage.getItem('user_subscription');
            if (subscriptionData) {
                this.subscription = JSON.parse(subscriptionData);
            }
            
            const permissionsData = localStorage.getItem('user_permissions');
            if (permissionsData) {
                this.permissions = JSON.parse(permissionsData);
            }
        } catch (error) {
            console.error('Error parsing user data from localStorage:', error);
        }
        
        // Redirect to login if no email is found
        if (!this.email) {
            this.$router.push('/login');
        }
    }
};
</script>

<style scoped>
.suscribirse-screen {
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100%;
    background-color: #f5f5f5;
    color: #333333;
    position: relative;
}

.main-screen-component {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100vh;
    width: 100%;
    overflow: hidden;
}

.main-screen {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    flex-grow: 1;
}

/* Toast notification */
.toast {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    padding: 12px 20px;
    border-radius: 4px;
    color: white;
    font-weight: 500;
    z-index: 1000;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    min-width: 250px;
    text-align: center;
}

.toast.info {
    background-color: #2196F3;
}

.toast.success {
    background-color: #4CAF50;
}

.toast.warning {
    background-color: #FF9800;
}

.toast.error {
    background-color: #F44336;
}

@media screen and (max-width: 768px) {
    .main-screen {
        flex-direction: column;
        flex-grow: 1;
        position: relative;
        width: 100%;
    }
}
</style>
